import React from 'react'
import { Link } from 'react-router-dom'
import ls from "local-storage";
import * as CONFIG from './_config'

class Page extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}
    };


    componentDidMount() {
        ls.set('redirectTo', window.location.href);
    }

    componentDidUpdate(prevProps, prevState) {
        ls.set('redirectTo', window.location.href);
    }

    render() {

        var url = this.props.match.params.page;
        var policies = CONFIG.DATA.COMPANY_POLICIES;
        var policy = null
        var policyExist = policies.some(function (pp) { 
            policy = pp.policie.find(p => p.url === url);
            return policy != null;
        });
        // console.log(policy);

        return (
            <div className="main-container full-width pt-5 mt-5">
                {CONFIG.DATA.THEME === 2 ?
                    <section id="apus-breadscrumb" className="breadcrumb-page apus-breadscrumb" style={{ backgroundColor: '#f3ffd9' }}>
                        <div className="container">
                            <div className="wrapper-breads">
                                <div className="wrapper-breads-inner">
                                    <div className="breadscrumb-inner">
                                        <h2 className="bread-title">Company Policies</h2>
                                        <ol className="breadcrumb">
                                            <li>
                                                <Link to="/">Home</Link>
                                            </li>
                                            <li>
                                                <Link to="/company-policies">Company Policies</Link>
                                            </li>
                                            <li>
                                                <span>{policy.name}</span>
                                            </li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    :
                    <div className="title-breadcrumb">
                        <div className="container">
                            <div className="title-breadcrumb-inner">
                                <header className="entry-header">
                                    <h1 className="entry-title">{policy.name}</h1>
                                </header>
                                <div className="breadcrumbs">
                                    <Link to="/">Home</Link>
                                    <span className="separator">/</span>
                                    <Link to="/company-policies">Company Policies</Link>
                                    <span className="separator">/</span>
                                    <span>{policy.name}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                }

                <div className='container'>
                    <div className="row">

                        <div className="vc_col-xs-12">
                            <div className="page-content default-page">
                                <article id="post-8436" className="post-8436 page type-page status-publish hentry">
                                    <div className="entry-content">
                                        <div className="vc_row wpb_row vc_row-fluid">
                                            <div className="row-container" style={{/* marginLeft:'25%',*/ marginTop: '25px' }} >
                                                <div className="wpb_column vc_column_container vc_col-sm-10">
                                                    <div className="vc_column-inner">
                                                        <div className="wpb_wrapper">
                                                            <h2 style={{ fontSize: '42px', color: '#dd2121', textAlign: 'center', fontFamily: 'Lobster', fontWeight: '400', fontStyle: 'normal' }} className="vc_custom_heading">{policy.name}</h2>
                                                            <div className="text-left" dangerouslySetInnerHTML={{__html: policy.text}} ></div>
                                                            {/* <div className="vc_empty_space" style={{ height: '150px' }}><span className="vc_empty_space_inner"></span></div> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </article>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default Page;



